import { render, staticRenderFns } from "./MensagemGlobal.vue?vue&type=template&id=c4547c98"
import script from "./MensagemGlobal.vue?vue&type=script&lang=js"
export * from "./MensagemGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports